import React from 'react';
import { Route, Switch } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import ContactsPage from './pages/ContactsPage';
import PlansPage from './pages/PlansPage';
import PlansCardSears from './pages/PlansCardSears';
import SearsPage from './pages/SearsPage';
import MenuTelcelPage from './pages/MenuTelcelPage';
import PaymentServicePage from './pages/PaymentServicePage';
import ExternalSitePage from './pages/ExternalSitePage';
import TelcelPlansPage from './pages/TelcelPlans';
import ScheduleTelcelBillPayments from './pages/ScheduleTelcelBillPayments';
import ScheduleTelcelBillPaymentsContract from './pages/ScheduleTelcelBillPaymentContract';
import TelcelPlansIdPage from './pages/TelcelPlansId';

const App = () => (
  <Switch>
    <Route exact path="/" component={HomePage} />
    <Route exact path="/service/:serviceId" component={ServicePage} />
    <Route  path="/contacts" component={ContactsPage} />
    <Route exact path="/plans" component={PlansPage} />
    <Route exact path="/plans-card-sears" component={PlansCardSears} />
    <Route exact path="/sears" component={SearsPage} /> 
    <Route exact path="/menuTelcel" component={MenuTelcelPage} /> 
    <Route exact path="/payment-service" component={PaymentServicePage} /> 
    <Route exact path="/external-site" component={ExternalSitePage} /> 
    <Route exact path="/telcel-plans" component={TelcelPlansPage} /> 
    <Route exact path="/telcel-plans/:id" component={TelcelPlansIdPage} /> 
    <Route exact path="/schedule-telcel-bill-payments" component={ScheduleTelcelBillPayments} /> 
    <Route exact path="/schedule-telcel-bill-payments-contract" component={ScheduleTelcelBillPaymentsContract} /> 
  </Switch>
);

export default App;